const makeValidHexColor = (color) => {
  if (color?.[0] !== '#' && (color?.length === 3 || color?.length === 6))
    return `#${color}`;
  return color;
};

export default makeValidHexColor;
